import { API } from "@/lib/api";
import { APIService } from "@/services/api";
import { Account } from "@/types/account";

const TempUsersService = new APIService<Account>(API.Users);
const AccountService = new APIService<Account>(API.Account);

// TODO: Remove TempUsersService usage from here once the API is ready.
export const fetchAccount = async () => {
  try {
    const account = await AccountService.get();
    return account;
  } catch (error) {
    console.error(error);
    try {
      const user = await TempUsersService.get();
      return user;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
};
